import { useReducer, ReactNode, useEffect } from "react";
import { fetcher, Methods } from "../../api";
import { authReducer } from "./reducers";
import { AuthStateContext, getApiRoot, initialValues } from "./utils";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(authReducer, initialValues);
  const existingToken = localStorage.getItem("token");

  const { authToken, refetch } = state;
  
  const logout = () => {
    fetcher({
      method: Methods.post,
      url: "/api/v2/rest-auth/logout/",
      authToken: authToken,
      data: {}
    }).then(() => {
      dispatch({ type: "logout" });
      window.location.reload();
    })
  }
  
  const value = {
    ...state,
    logout,
    authDispatch: dispatch
  }

  useEffect(() => {
    if (existingToken) {
      dispatch({ type: "setToken", data: existingToken });
    }
  }, [existingToken]);

  useEffect(() => {
    if (refetch) {
      getApiRoot(authToken).then((res) => {
        const { user, mapUrl } = res;
        dispatch({
          type: "setUser",
          data: user
        });
        dispatch({
          type: "setRootData",
          data: { mapUrl }
        })
      })
    }
  }, [authToken, refetch])

  
  return (
    <AuthStateContext.Provider value={value}>
      {children}
    </AuthStateContext.Provider>
  )
}
